import IngkaToast, { ToastProps } from '@ingka/toast';
import React from 'react';

const Toast = (props: ToastProps) => (
    <IngkaToast prefix="list-ingka-" {...props} />
);

export default Toast;
